// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".carousel-chevron{display:flex;flex-wrap:wrap;grid-gap:20px;gap:20px}.carousel-chevron .arrow-left,.carousel-chevron .arrow-right{height:auto;width:auto;padding:10px;border:2px solid #000;border-radius:3px;cursor:pointer;color:inherit!important}.carousel-chevron .arrow-left svg,.carousel-chevron .arrow-right svg{height:20px;width:20px}.carousel-chevron .arrow-left svg:hover,.carousel-chevron .arrow-right svg:hover{fill:var(--theme__color3);color:var(--theme__color3)}", ""]);
// Exports
module.exports = exports;
